






































































// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {IItemPanier, ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { getDefaultAloArbo } from '@/models/alo/AloArbo'
import MenuBreakfastSection from '@/components/carte/MenuBreakfastSection.vue'
import MenuBreakfastCarte from '@/components/carte/MenuBreakfastCarte.vue'
import MenuBreakfastEditCarte from '@/components/carte/MenuBreakfastEditCarte.vue'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import PlatEditable from '@/components/carte/PlatEditable'
import { groupByNumber } from '@/utils/groupBy'
import CartItem from '@/components/panier/CartItem.vue'


@Component({
  name: 'ProduitMenuBreakfast',  
  props:{
    reset:{
      type:Boolean,
      default:false
    }   
  },
  components:{MenuBreakfastSection,MenuBreakfastCarte,MenuBreakfastEditCarte,CartItem}
})
export default class ProduitMenuBreakfast extends mixins(BasePlat,PlatEditable) {  
  reset!:boolean    
  showSection = false  
  showCarte = false        
  showConfirmAdd = false

  public selectedPlat:AloPlat = getDefaultAloPlat()



  get platSelected(){
    return this.plat.selected
  }
  
  get platsDic(){    
    return this.$store.myGetters.platsDic
  }
  
  get plats() {
    return this.plat.platsIds?.map(id => this.platsDic[id]) || []
  }

  get menuItems() {
    return this.plats.filter(p => p.template == "plat-produit-menu-breakfast-item")
  }

  get defaultItems() {
    return this.plats.filter(p => p.template == "plat-produit-menu-breakfast-default-item")
  }

  get carteItems() {
    return this.plats.filter(p => p.template == "plat-produit-menu-breakfast-default-carte")
  }

  get supplementsGroup(){
    return groupByNumber(this.itemPanier.supplements, it => it.sectionId || 0).map(it => {return {...it, section: this.platsDic[it.key] || getDefaultAloPlat()}})
  }

  @Watch("plat")
  onPlatChange(){    
    this.resetItemPanier()
  }

  @Watch("reset")
  onReset(){
    if(this.reset) this.resetItemPanier()
  }

  mounted() {
    //on est dans le cas d'un nouveau panier
    if(this.itemPanier.plat.id == 0) this.resetItemPanier()
  }

  resetItemPanier(){
     //construction des options    
    const options = [...this.menuItems,...this.carteItems]?.reduce((dic,item)=> {
                                                            dic[item.id!] = []
                                                            return dic
                                                        },{} as {[platId:number]:Array<IItemPanier>})
    this.itemPanier = new ItemPanier({plat:this.plat,qty:1,options,parentId:this.platParentId,sectionId:this.platSectionId,arboId:this.platArboId})
  }


  selectProduct() {  
    this.resetItemPanier()     
    this.$store.myActions.ROOM_SERVICES_PLAT_SET_SELECTION({selected:true,ids:[this.plat.id]})       
  }

  cancel() {
    if(this.isEdited){
      this.$emit("cancel")
    }
    else{    
      this.resetItemPanier()      
    }
  }

  get missingOptions() {    
    return this.menuItems?this.menuItems.reduce((alert,item) => {
      const nbMissing = item.qty! - (this.itemPanier.options![item.id].reduce((total,item) => total + item.qty,0) || 0)      
      //@ts-ignore
      if(nbMissing > 0) alert.push(this.$tc("Dish.MissingOptionItemAlert",nbMissing,{plat:this.$gt(item).libelle}))      
      return alert
    },[] as Array<string>):[]   
  }

  showConfirmAddMessage() {    
    if(!this.canAdd) this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)    
    else { 
      if(this.itemPanier.nbAccompagnements < (this.plat.qtyAccompagnementGratuit || 0)) { 
        this.$confirm(this.$tc('Dish.AlertSideDishes',this.plat.qtyAccompagnementGratuit||0),{title: this.$t('Dish.AlertSideDishesTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)      
      }
      else if(this.missingOptions.length > 0) {
        //@ts-ignore
        this.$confirm(this.$t("Dish.MissingOptionAlert", {message:this.missingOptions.join("</li><li>"),plat:this.$gt(this.plat).libelle}),{title: this.$t('Dish.MissingOptionAlertTitle'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then((reponse)=>{
          if(reponse){
            this.showConfirmAdd = true
          }
        }) 
      }
      else {      
        this.showConfirmAdd = true
      }
    }
  }

  backToConfig(){
    this.showConfirmAdd = false
    this.itemPanier.qty = 1
  }

  addItemToPanier() { 
    if(!this.canAdd)  this.$confirm(this.$t('Cart.AlertProductMix').toString(),{title: this.$t('Cart.AlertProductMixTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    else 
    {
      this.showConfirmAdd = false
      this.addToCart(this.itemPanier) 
      this.cancel()      
    }
  }
  
  addSupplement(itemPanier:ItemPanier) {    
    const it = this.itemPanier.supplements.find(it => it.hasSameConfig(itemPanier))
    if(it) it.qty++;
    else this.itemPanier.supplements.push(itemPanier)

    //On affiche un popup de confirmation d'ajout avec Retour menu, ou Continuer ajout
    //@ts-ignore    
    this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.$tc('Dish.SnackAddBreakfastSupplement',itemPanier.qty,{plat:this.$gt(itemPanier.plat).libelle,prix:this.$options.filters.currency(itemPanier.prixTotalAvecOptions)}))        
    this.showCarte = false
  }

  selectOption(plat:AloPlat){
    this.selectedPlat = plat    
    this.showSection = true    
  }

  editSupplement(){
    (this.$refs.editSupplement as MenuBreakfastEditCarte).edit(this.itemPanier)
  }

}
